import { BaseModel } from '../base-model';
import { NotificacaoSistema } from './notificacao-sistema';
import { PessoaFisica } from './pessoa-fisica';

export class NotificacaoSistemaLido extends BaseModel {
  constructor(
    public id: number,
    public dtNotificacaoLida: Date,

    public notificacaoSistemaId: number,
    public notificacaoSistema: NotificacaoSistema,

    public pessoaFisicaId: number,
    public pessoaFisica: PessoaFisica,
  ) { super(); }
}

